// extracted by mini-css-extract-plugin
export var scrollArea = "_q0-0";